import React, { useState } from "react";
import HomeMenuBar, { HomeMenuBarProps } from "../MenuBar/HomeMenuBar";

interface PageContainerProps {
  HomeMenuBarprops?: HomeMenuBarProps;
  additionalProps?: any;
  children: React.ReactNode;
}

const PageContainer: React.FC<PageContainerProps> = ({
  HomeMenuBarprops,
  children,
  additionalProps,
}) => {
  return (
    <div
      className="app-page-bg"
      style={{
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
        paddingBottom: "3vh",
      }}
    >
      <HomeMenuBar {...HomeMenuBarprops} />
      <div 
        style={{
          width: "100%",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default PageContainer;
